import { ColumnDef } from "@tanstack/react-table";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useNavigate } from "react-router-dom";
import { getPerfectDate } from "../../helpers/utils";
import { useAppStore } from "../../stores/RootStore";
import { DevicesTableData } from "../../types/formDataTypes";
import { Badge } from "../../ui/Badge";
import { Button } from "../../ui/Button";
import { MenuDataTable } from "../../ui/DataTable/MenuDataTable";
import { Input } from "../../ui/Input/Input";
import DevicesFilters from "./devicesComponents/DevicesFilters";
import _ from "lodash";

type CategoriesType = {
    unique_types: Array<string>;
  };
  
  type FilterType = {
    types: Array<string>;
  };
    

export default function DevicesGrid({onClose}:{onClose: () => void}) {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const devices = useAppStore((state) => state.devices);
    const [search, setSearch] = useState("");
    const [filter, setFilter] = useState<FilterType>({
      types: [],
    });
    const [selected, setSelected] =  useState<DevicesTableData>();
  
    let nodes = devices?.map((device) => {
      return {
        id: device.id,
        serial_number: device.attributes.serial_number,
        model: device.attributes.model,
        initialized_at: getPerfectDate(device.attributes.initialized_at),
        sensor_types: device.attributes.sensor_types!.map((item) => item.data_key_name),
        online: device.attributes.online,
        slots: device.attributes.slots
      };
    });
  
    const categories: CategoriesType = {
      unique_types: [],
    };
  
    // Создание массивов с уникальными названиями для категорий фильтра
    if (nodes) {
      for (let i = 0; i < nodes.length; i++) {
        const elem = nodes[i];
        elem.sensor_types.forEach((element) => {
          if (!categories.unique_types.includes(element)) categories.unique_types.push(element);
        });
  
        // if (!categories.unique_statuses.includes(elem.status)) categories.unique_statuses.push(elem.status);
      }
    }
  
    let data = { nodes };
  
    const handleSearch = (event: any) => {
      setSearch(event.target.value);
    };
  
    // Фильтрация через поиск
    data = {
      nodes: data.nodes?.filter(
        (item) => item.serial_number.toLowerCase().includes(search.toLowerCase()) //||
        // item.access_token_id?.toLowerCase().includes(search.toLowerCase())
      ),
    };
    
    //Фильтрация через категории
    data = {
      nodes: _.orderBy(data.nodes?.filter(
        (item) =>
          filter.types.length > 0
            ? item.sensor_types.some((element) => {
                if (filter.types.includes(element)) return true;
              })
            : true //&&
        // (filter.statuses.length > 0 ? filter.statuses.includes(item.status) : true)
      ), "online", "desc"),
    };


  
    const columns: ColumnDef<DevicesTableData>[] = [
      {
        id: "equipment_type_name",
        accessorFn: (row) => `${row.serial_number}`,
        header: t("equipment_name"),
        size: 1000,
        cell: (props) => (
          <div className="max-w-[380px]">
            <div className="font-medium truncate ">{props.row.original.serial_number}</div>
          </div>
        ),
      },
      {
        accessorKey: "online",
        header: t("status"),
        size: 100,
        maxSize: 100,
        minSize: 100,
        cell: (props) => (
            props.row.getValue("online") ? (
              <Badge variant={"default"} className="bg-green-600 text-white">{t('online')}</Badge>
            ) : (
              <Badge variant={"default"} className="bg-red-600 text-white">{t('offline')}</Badge>
            )
        ),
      },
    ];
  
  
  
    function selectDevice(device: DevicesTableData) {
      navigate(`/data/devices/${device.id}`)
      setSelected(device)
      onClose()
    }
  
    function addDevice() {
      navigate("/data/devices/new")
      onClose()
    }

  return (
    <>
        <div className="flex flex-col">
          <div className="flex flex-row w-full h-14 items-center gap-4 px-6 justify-between">
            <Input 
              className="h-8"
              placeholder={t("equipment_search")}
              onChange={handleSearch}
              value={search}
              autoComplete="off"
              width="100%" 
            />
            {/* <DevicesFilters filterState={[filter, setFilter]} categories={categories} /> */}
            <Button variant={"default"} size={"md"} onClick={() => addDevice()}>{t('add')}</Button>
          </div>
        </div>
        
        {!data.nodes?.length ? ( // Заглушка для отсутствия данных при поиске
          <div className="flex w-full h-full justify-center items-center">
            {t("no_data")}
          </div>
        ) : (
          <MenuDataTable route="/data/devices" data={data.nodes} columns={columns} onClickRow={selectDevice}/>
        )}
  </>
  )
} 
